import { render } from "./FavouritesView.vue?vue&type=template&id=29c28877&scoped=true"
import script from "./FavouritesView.vue?vue&type=script&lang=js"
export * from "./FavouritesView.vue?vue&type=script&lang=js"

import "./FavouritesView.vue?vue&type=style&index=0&id=29c28877&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c28877"]])

export default __exports__